import { Expose } from 'class-transformer'

export default class LeadPracticeFormError {
  lead_id: string[] = []
  address: string[] = []
  line1: string[] = []
  line2: string[] = []
  city: string[] = []
  county: string[] = []
  country: string[] = []
  postcode: string[] = []
  lat: string[] = []
  lng: string[] = []
  agreed_contracts: string[] = []
  affiliate_code: string[] = []
  marketing_channel: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}
